"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.linkedinSearchOrganization = exports.linkedinSearchOrganizationResultSchema = exports.linkedinSearchOrganizationArgsSchema = void 0;
var zod_1 = require("zod");
var common_1 = require("./common");
exports.linkedinSearchOrganizationArgsSchema = (0, common_1.PipedreamNodeArgsSchema)('search-organization', zod_1.z.object({
    searchBy: zod_1.z.string().describe('Field to search by: vanityName or emailDomain'),
    searchTerm: zod_1.z.string().describe('Keyword to search for'),
    max: zod_1.z.number().nullish().describe('Maximum number of results to return'),
}));
var linkedinOrganizationSchema = zod_1.z.object({
    id: zod_1.z.string().describe('The id of the organization'),
    name: zod_1.z.string().describe('The name of the organization'),
    vanityName: zod_1.z.string().describe('The vanity name of the organization'),
    localizedName: zod_1.z.string().describe('The localized name of the organization'),
    localizedWebsite: zod_1.z.string().describe('The localized website of the organization'),
    logoV2: zod_1.z.string().describe('The logo of the organization'),
    location: zod_1.z.string().describe('The location of the organization'),
});
exports.linkedinSearchOrganizationResultSchema = (0, common_1.PipedreamNodeResultSchema)(zod_1.z.array(linkedinOrganizationSchema));
exports.linkedinSearchOrganization = (0, common_1.createToolMetadata)({
    id: 'linkedinSearchOrganization',
    displayName: 'LinkedIn Search Organization',
    displayDescription: 'Search for a LinkedIn organization by vanity name or email domain',
    category: 'social',
    color: common_1.BRAND_COLORS.LINKEDIN,
    backgroundColor: (0, common_1.createBgColor)(common_1.BRAND_COLORS.LINKEDIN),
    icon: 'linkedin',
    argsSchema: exports.linkedinSearchOrganizationArgsSchema,
}, exports.linkedinSearchOrganizationResultSchema);
